export const AGENDA_DATA = {
  AGENDA_NAME_MAX_LENGTH: 80,
  OVERVIEW_AGENDA_NAME_MAX_LENGTH: 25,
  EDIT_SUMMARY_TYPE: {
    INTERVENTION_SUMMARY: "EDIT_INTERVENTIAN_SUMMARY",
    AGENDA_SUMMARY: "EDIT_AGENDA_ITEM_SUMMARY",
  },
  AGENDA_STATUS: {
    START: "START",
    PAUSE: "PAUSE",
    RESUME: "RESUME",
    STOP: "STOP",
    CREATE: "CREATE",
    UPDATE: "UPDATE",
  },
  SUMMARY_SHOW_TYPE: { SHOW_LESS: "show_less", EXPAND: "show_more" },
};
